<template>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
            <label for="country" class="block text-white text-sm 2xl:text-base mb-2">Country<span class="text-red-500">*</span></label>
            <div class="relative">
                <SelectInput
                    v-model="formData.country"
                    :options="countries" 
                    id="country"
                    placeholder="Select country" 
                    class="w-full"
                ></SelectInput>
            </div>
        </div>

        <div>
            <label for="postal_code" class="block text-white text-sm 2xl:text-base mb-2">Postal Code<span class="text-red-500">*</span></label>
            <div class="relative">
                <TextInput type="text" id="postal_code" placeholder="Postal Code" class="w-full" @input="validatePostalCode()" :disabled="!formData.country" v-model="formData.postal_code"/>
            </div>
            <p v-if="postalCodeError" class="text-red-500 text-xs 2xl:text-sm mt-1">{{ postalCodeError }}</p>
        </div>

    </div>
</template>

<script setup>
import { ref, onMounted, watch, defineEmits } from 'vue';
import axios from '@/plugins/axios';
import postalCodePatterns from '@/data/postalCodePatterns.json';
import { useLayoutComponents } from '@/composables/layout.js';
const { TextInput, SelectInput} = useLayoutComponents();

const countries = ref([]);
const postalCodeError = ref('');
const emit = defineEmits(['change']);
const formData = ref({
    country: null,
    postal_code: null
});
const handleChange = () => {
    emit('change', {
        country: formData.value.country,
        postal_code: formData.value.postal_code
    });
}

watch(formData.value, () => {
    handleChange()
}, { deep: true })

const fetchCountries = async () => {
    const response = await axios.get('https://restcountries.com/v3.1/all?fields=name,cca2');
    countries.value = response.data.map(country => ({
        label: country.name.common,
        value: country.cca2
    }));
}


const validatePostalCode = () => {
    const postalCode = document.getElementById('postal_code').value;
    const selectedCountry = formData.value.country;
    postalCodeError.value = '';

    if (!postalCode) {
        postalCodeError.value = 'Postal code is required';
        return;
    }

    if (!formData.value.country) {
        postalCodeError.value = 'Please select a country first';
        return;
    }

    const pattern = postalCodePatterns[selectedCountry];
    if (pattern) {
        const regex = new RegExp('^' + pattern + '$');
        if (!regex.test(postalCode)) {
            postalCodeError.value = 'Invalid postal code format for selected country';
        }
    }
}

onMounted(() => {
    fetchCountries();
});
</script>